import './Goals.scss'
import DataTable from 'react-data-table-component';
import { useContext, useEffect, useState } from 'react';
import { MVOContext } from '../../Contexts/MVOprovider';
import Loading from '../../Components/Loading';
export default function Goals(){
  const { updateChartType,MVO,loading,refreshMVO } = useContext(MVOContext)
  useEffect(()=>{
    document.title = "Goals"
    refreshMVO()
  },[refreshMVO])
  const columns = [
    {
      selector: row => <img alt='img' className='ImageLogo' src={row.icon}></img>,
      grow:true
  },
    {
      name: 'Name',
      selector: row => row.name,
      minWidth: "50%"
  },
  {
    name: 'Chart type',
    selector: row => <select onChange={(event) => {saveToDB(event,row.MVOgoalId)}} value={row.chartType}>
        <option value="bar">bar</option>
        <option value="line">line</option>
        <option value="area">area</option>
        <option value="ring">ring</option>
        <option value="pie">pie</option>
      </select>,
      grow:true
  },
  {
    name: 'SDG',
    selector: row => row.sdg.name,
    
},
{
  name: 'Target value',
  selector: row => row.targetValue + " " + row.unit,
},

];
const [pages,setPages] = useState();
const [data, setData] = useState();
useEffect(() => {
  if (window.innerHeight >= 850){
    setPages(10)
  }
  else if(window.innerHeight < 675){
    setPages(7)
  }
  else{
    setPages(10)
  }
  setData(MVO)
},[MVO])
function saveToDB(event,id){
  if(event != null){
      updateChartType(id,event.target.value)

  }
}
if(loading){
  return <Loading type="spin" color="#004C69"/>
}
  return (
      <div className='GoalsContainer' data-cy="goals">
        {MVO.length > -1 && loading === false &&
                <DataTable
                columns={columns}
                data={data}
                pagination
                responsive={true}
                paginationPerPage={pages}

            />
        }
      </div>
  );
}